export default __webpack_public_path__ + "static/media/inner6.44cbb8d6.jpg";